// extracted by mini-css-extract-plugin
export default {"container":"style_container__es-df","title":"style_title__cg-2b","content":"style_content__mqo4h"};